<mat-card class="no-overflow margin all" *ngIf="selectedCylinder">
  <mat-card-header class="operated-header">
    <mat-card-title>Operated By</mat-card-title>
    <div *ngIf="!editing" class="row center">
      <button
        *ngIf="selectedCylinder?.isDefaultCylinder"
        class="small-icon-button"
        (click)="toggleEdit()"
        mat-icon-button
      >
        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
      </button>
      <button *ngIf="expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
      </button>
      <button *ngIf="!expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_less</mat-icon>
      </button>
    </div>

    <div *ngIf="editing" class="row center">
      <button mat-stroked-button *ngIf="isCrossKeyedCylinder()" (click)="addXKeyOperators()" class="margin left">
        Add
      </button>
      <button (click)="toggleEdit()" mat-stroked-button class="margin left">Close</button>
      <button mat-icon-button class="marginleft" [matMenuTriggerFor]="operatedByActions">
        <mat-icon>more_vert</mat-icon>
      </button>
    </div>
  </mat-card-header>

  <mat-menu #operatedByActions class="operated-by-actions">
    <button
      mat-menu-item
      (click)="addCylinder()"
      class="margin left"
      [color]="'#393E46'"
      [small]="true"
      [disabled]="!keysForm.valid"
      *ngIf="!isCrossKeyedCylinder()"
    >
      Add operator and create new cylinder
    </button>
    <button
      mat-menu-item
      (click)="addOperators()"
      class="margin left"
      [color]="'#393E46'"
      [small]="true"
      [disabled]="!keysForm.valid"
      *ngIf="!isCrossKeyedCylinder()"
    >
      Add operator to existing cylinder
    </button>
    <button mat-menu-item (click)="deleteConfirm()" class="margin left" [color]="'#393E46'" [small]="true">
      Delete
    </button>
  </mat-menu>

  <!-- Minimize -->
  <div [@fadeInOnly] *ngIf="expanded || editing">
    <!-- No Operators -->
    <app-nothing-here *ngIf="selectedCylinder?.operators?.length === 0 && !editing && expanded">
      <h6>{{ selectedCylinder?.name }} has no operators, click the edit icon to add some.</h6>
    </app-nothing-here>

    <div class="operators-form" *ngIf="editing">
      <div
        class="custom lrg padding sm right bottom left"
        title="Enter individual keys separated by a comma or the star symbol before any master symbol for maison, ex *GGM or *AA
      or *AB"
      >
        Enter individual keys separated by a comma or the star symbol before any master symbol for maison, ex *GGM or
        *AA or *AB
      </div>

      <form [formGroup]="keysForm" autocompete="off">
        <div [padding]="0" class="row center">
          <!-- Key Name -->
          <mat-form-field appearance="outline" class="fill padding sm right left">
            <mat-label
              [ngClass]="{
                'error-message': fieldHasError(keysForm, 'keys'),
                focus: focus.keys
              }"
              >Key Name/s</mat-label
            >

            <input
              class="uppercase"
              id="keys"
              placeholder="Enter Key Name/s"
              formControlName="keys"
              (focus)="focusOn('keys')"
              (focusout)="focusOn('keys')"
              autocomplete="no"
              cdkFocusInitial
              matInput
              aria-describedby="keys"
              autofocus
            />

            <mat-icon *ngIf="fieldHasError(keysForm, 'keys')" [color]="'#EE6352'">warning</mat-icon>

            <!-- Errors -->
            <div *ngFor="let validation of errorMessages.keys">
              <div
                class="caption error-message"
                *ngIf="fieldHasErrorMessages(keysForm, validation, 'keys')"
                id="keysErrors"
              >
                {{ validation.message }}
              </div>
            </div>
          </mat-form-field>

          <div class="input-spacer padding sm right left"></div>
        </div>
      </form>

      <div *ngIf="isCrossKeyedCylinder()">
        <!-- Operators Form -->
        <form [formGroup]="operatorsForm" autocompete="off" class="">
          <div class="custom lrg padding sm right bottom left">AND/OR Enter groups of keys by range</div>

          <div [padding]="0" class="row center">
            <!-- Prefix -->
            <mat-form-field appearance="outline" class="padding sm right left">
              <mat-label
                [ngClass]="{
                  'error-message': fieldHasError(operatorsForm, 'prefix'),
                  focus: focus.prefix
                }"
              >
                Prefix</mat-label
              >
              <input
                class="uppercase"
                id="prefix"
                placeholder="Enter a Name/Prefix"
                formControlName="prefix"
                (focus)="focusOn('prefix')"
                (focusout)="focusOn('prefix')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="Job name"
              />

              <mat-icon *ngIf="fieldHasError(operatorsForm, 'prefix')" [color]="'#EE6352'">warning </mat-icon>

              <!-- Errors -->
              <div *ngFor="let validation of errorMessages.prefix">
                <div
                  class="caption error-message"
                  *ngIf="fieldHasErrorMessages(operatorsForm, validation, 'prefix')"
                  id="prefixErrors"
                >
                  {{ validation.message }}
                </div>
              </div>
            </mat-form-field>

            <!-- From -->
            <mat-form-field appearance="outline" class="padding sm right left">
              <mat-label
                [ngClass]="{
                  'error-message': fieldHasError(operatorsForm, 'from'),
                  focus: focus.from
                }"
              >
                From</mat-label
              >

              <input
                class="uppercase"
                id="from"
                placeholder="Enter From Value"
                formControlName="from"
                (focus)="focusOn('from')"
                (focusout)="focusOn('from')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="Job name"
              />

              <mat-icon *ngIf="fieldHasError(operatorsForm, 'from')" [color]="'#EE6352'">warning </mat-icon>

              <!-- Errors -->
              <div *ngFor="let validation of errorMessages.from">
                <div
                  class="caption error-message"
                  *ngIf="fieldHasErrorMessages(operatorsForm, validation, 'from')"
                  id="fromErrors"
                >
                  {{ validation.message }}
                </div>
              </div>
            </mat-form-field>

            <!-- To -->
            <mat-form-field appearance="outline" class="padding sm right left">
              <mat-label
                [ngClass]="{
                  'error-message': fieldHasError(operatorsForm, 'to'),
                  focus: focus.to
                }"
              >
                To</mat-label
              >

              <input
                class="uppercase"
                id="to"
                placeholder="Enter To Value"
                formControlName="to"
                (focus)="focusOn('to')"
                (focusout)="focusOn('to')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="Job name"
              />

              <mat-icon *ngIf="fieldHasError(operatorsForm, 'to')" [color]="'#EE6352'">warning </mat-icon>

              <!-- Errors -->
              <div *ngFor="let validation of errorMessages.to">
                <div
                  class="caption error-message"
                  *ngIf="fieldHasErrorMessages(operatorsForm, validation, 'to')"
                  id="toErrors"
                >
                  {{ validation.message }}
                </div>
              </div>
            </mat-form-field>

            <!-- Suffix -->
            <mat-form-field appearance="outline" class="padding sm right left">
              <mat-label
                [ngClass]="{
                  'error-message': fieldHasError(operatorsForm, 'suffix'),
                  focus: focus.suffix
                }"
              >
                Suffix</mat-label
              >

              <input
                class="uppercase"
                id="suffix"
                placeholder="Enter a Suffix"
                formControlName="suffix"
                (focus)="focusOn('suffix')"
                (focusout)="focusOn('suffix')"
                autocomplete="no"
                cdkFocusInitial
                matInput
                aria-describedby="Job name"
              />

              <mat-icon *ngIf="fieldHasError(operatorsForm, 'suffix')" [color]="'#EE6352'">warning </mat-icon>

              <!-- Errors -->
              <div *ngFor="let validation of errorMessages.suffix">
                <div
                  class="caption error-message"
                  *ngIf="fieldHasErrorMessages(operatorsForm, validation, 'suffix')"
                  id="suffixErrors"
                >
                  {{ validation.message }}
                </div>
              </div>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>

    <!-- Cylinders Data Table -->
    <app-data-table
      *ngIf="selectedCylinder?.operators?.length > 0 && (expanded || editing)"
      #table
      [tableName]="'cylinders'"
      [viewPageSize]="50"
      [displayColumns]="cylindersDisplayColumns"
      [subject]="filteredCylinders"
      [pagination]="false"
      [searchDisabled]="true"
      [heightOffset]="50"
    >
    </app-data-table>
  </div>
</mat-card>
